export default {
  apiTrafficManager: process.env.VUE_APP_BACKEND_URL || 'https://nakdan-u2-1a.loadbalancer.dicta.org.il',
  withinNakdan: true
}
